"use client";

import { useStyles } from "./styles";
import { useAppSelector } from "@/redux/store";
import DailyGensSummary from "../DailyGensSummary";

const Header = () => {
  const { classes } = useStyles();
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user.subscriptionType !== "free");

  if (isSubscribed) {
    return (
      <h1 className={classes.heading}>
        Create something <span>extraordinary</span>
      </h1>
    );
  }

  return <DailyGensSummary />;
};

export default Header;
